import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const projects = [{
  id: 1,
  title: "Sommet Africain des Leaders",
  category: "Événementiel",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573891/img/project_event_summit_leaders.png",
  size: "large",
  link: "/ProjectsPage"
}, {
  id: 2,
  title: "Rebranding Bank of Africa",
  category: "Branding",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573891/img/project_branding_boa.png",
  size: "standard",
  link: "/ProjectsPage"
}, {
  id: 3,
  title: "Campagne Digitale Orange",
  category: "Digital",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573891/img/project_digital_orange.png",
  size: "standard",
  link: "/ProjectsPage"
}, {
  id: 4,
  title: "Rapport Annuel SONABEL",
  category: "Stratégie",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573891/img/project_strategy_sonabel.png",
  size: "standard",
  link: "/ProjectsPage"
}, {
  id: 5,
  title: "Lancement Canal+ Business",
  category: "Événementiel",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573891/img/project_event_canal_plus.png",
  size: "wide",
  link: "/ProjectsPage"
}];
export default function ApercuDeNosRealisations() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="aperçu-de-nos-réalisations" className="bg-background py-20 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6">
        {}
        <div ref={ref} className={cn("flex flex-col md:flex-row justify-between items-start md:items-end gap-6 mb-12 transition-all duration-700 transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <div className="max-w-2xl">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold tracking-tight mb-4 text-foreground">
              Aperçu de nos Réalisations
            </h2>
            <p className="text-muted-foreground text-lg max-w-xl">
              Une sélection de projets où stratégie, créativité et excellence
              opérationnelle se rencontrent pour créer un impact durable.
            </p>
          </div>
          <Button asChild variant="outline" className="hidden md:inline-flex group">
            <Link to="/ProjectsPage">
              Voir tous les projets
              <ArrowUpRight className="ml-2 size-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
            </Link>
          </Button>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 auto-rows-[300px] md:auto-rows-[280px]">
          {projects.map((project, i) => <Link key={project.id} to={project.link} data-index={i} className={cn("group relative overflow-hidden rounded-xl bg-muted border border-border/50 shadow-sm transition-all duration-500 hover:shadow-md block", project.size === "large" && "md:col-span-2 md:row-span-2", project.size === "wide" && "md:col-span-2 md:row-span-1", project.size === "standard" && "md:col-span-1 md:row-span-1", "col-span-1", project.size === "large" ? "row-span-2" : "row-span-1")}>
              {}
              <div className="absolute inset-0 size-full">
                <img src={project.image} alt={project.title} className="size-full object-cover transition-all duration-700 grayscale group-hover:grayscale-0 group-hover:scale-105" />
                {}
                <div className="absolute inset-0 bg-chart-1/0 transition-colors duration-500 group-hover:bg-chart-1/20 mix-blend-multiply" />
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-500" />
              </div>

              {}
              <div className="absolute inset-0 p-6 flex flex-col justify-end items-start">
                <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500 ease-out">
                  <Badge variant="secondary" className="mb-3 font-mono text-xs tracking-wider uppercase bg-background/90 text-foreground backdrop-blur-sm border-none">
                    {project.category}
                  </Badge>
                  <h3 className="text-xl md:text-2xl font-bold text-white font-serif leading-tight mb-1">
                    {project.title}
                  </h3>
                  <div className="h-0 overflow-hidden group-hover:h-auto group-hover:mt-2 transition-all duration-500">
                    <span className="inline-flex items-center text-sm font-medium text-white/90">
                      Découvrir le projet <ArrowUpRight className="ml-1 size-3" />
                    </span>
                  </div>
                </div>
              </div>
            </Link>)}
        </div>

        {}
        <div className="mt-8 md:hidden text-center">
          <Button asChild variant="outline" className="w-full sm:w-auto group">
            <Link to="/ProjectsPage">
              Voir tous les projets
              <ArrowUpRight className="ml-2 size-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}